import context from "./lib/audio-context.civet"

bufferLoader := (url: string) ->
  response := await fetch(url)
  throw response unless response.ok
  buffer := await response.arrayBuffer()

  new Promise<AudioBuffer> (resolve, reject) ->
    // TODO Safari may not support promise based decodeAudioData yet
    context.decodeAudioData buffer, resolve, reject

{ BASE_PATH } from ./const.civet
urlFor := (path: string) ->
  `${BASE_PATH}${path}`

export fx := {
  eraser: undefined as AudioBuffer?
}

// Load Editor sound effects, currently just the eraser
bufferLoader(`${BASE_PATH}erase2.wav`)
.then (buffer) ->
  Object.assign fx,
    eraser: buffer

samples :=
  synth:
    sample: "synth.wav"
  piano:
    sample: "piano.wav"
    pan: -0.5
  guitar:
    sample: "guitar.wav"
    pan: 0.25
  bass:
    sample: "16.wav"
  horn:
    sample: "horn.wav"
    pan: -0.333
  orch_hit:
    sample: "orch_hit.wav"
    pan: 0.25
  chime:
    sample: "5.wav"
    pan: 0.5
  organ:
    sample: "organ.wav"
    pan: -0.25
  drum:
    sample: "drum.wav"
  snare:
    sample: "snare.wav"
  woodblock:
    sample: "14.wav"
    pan: -0.333
  clap:
    sample: "clap.wav"
  hat:
    sample: "hat.wav"
    pan: 0.333
  baby:
    sample: "baby.wav"
    pan: -0.5
  yoshi:
    sample: "yoshi.wav"
    pan: 0.5
  pig:
    sample: "oink.wav"
  cat:
    sample: "cat.wav"
    pan: 0.25
  dog:
    sample: "dog.wav"
    pan: -0.25
  french:
    sample: "french-horn.wav"
    pan: 0.333
    pitchShift: 0
  nylon:
    sample: "nylon-guitar2.wav"
    pan: -0.25
    pitchShift: -12
  snare2:
    sample: "snare2.wav"
    pitchShift: 0

defaultPack := Object.keys(samples).map (name, i) ->
  sample := samples[name]
  sample.name = name
  sample.index = i
  sample.pitchShift ?= -5 // These samples are pitched to F, the -5 pitches them to C
  sample.pan ?= 0
  sample.volume ?= 1

  sample as SampleData

Sample :=
  load: (data: SampleData ) ->
    {sample} := data

    // Load audio buffer
    buffer := bufferLoader urlFor sample

    Object.assign data,
      buffer: buffer

export default Sample
export { Sample, defaultPack }

export type SampleData = {
  name: string
  index: number
  sample: string
  buffer: AudioBuffer
  pitchShift: number
  pan: number
  volume: number
}
